<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data.exhibitor?.name"
  [description]="'Status: ' + data.status"
  [media]="imageUrl"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
